import { staffFulfilmentViewSchema, staffRequestAttachmentDownloadSchema, staffRequestAttachmentResultSchema, staffRequestAttachmentUploadTargetSchema, staffRequestCommandResultSchema, staffRequestCustomerUpdateResultSchema, staffRequestEvidenceResultSchema, } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
import { staffRequestPath } from "./staff-requests";
export function createStaffRequestEvidenceApi(options) {
    const send = createMemoryTransport(options);
    const post = (path, body, schema, commandOptions) => send({
        method: "POST",
        path,
        body,
        schema,
        idempotencyKey: commandOptions?.idempotencyKey,
        signal: commandOptions?.signal,
    });
    const base = (requestId) => staffRequestPath(requestId);
    return {
        get: (requestId, callOptions) => send({
            method: "GET",
            path: `${base(requestId)}/evidence`,
            schema: staffFulfilmentViewSchema,
            signal: callOptions?.signal,
        }),
        record: (requestId, input, o) => post(`${base(requestId)}/evidence`, input, staffRequestEvidenceResultSchema, o),
        publishUpdate: (requestId, input, o) => post(`${base(requestId)}/customer-updates`, input, staffRequestCustomerUpdateResultSchema, o),
        createAttachmentUploadTarget: (requestId, input, o) => post(`${base(requestId)}/attachments/upload-target`, input, staffRequestAttachmentUploadTargetSchema, o),
        addAttachment: (requestId, input, o) => post(`${base(requestId)}/attachments`, input, staffRequestAttachmentResultSchema, o),
        getAttachmentDownload: (requestId, attachmentId, callOptions) => send({
            method: "GET",
            path: `${base(requestId)}/attachments/${encodeURIComponent(attachmentId)}/download`,
            schema: staffRequestAttachmentDownloadSchema,
            signal: callOptions?.signal,
        }),
        shareAttachment: (requestId, attachmentId, input, o) => post(`${base(requestId)}/attachments/${encodeURIComponent(attachmentId)}/share`, input, staffRequestAttachmentResultSchema, o),
        markUnavailable: (requestId, input, o) => post(`${base(requestId)}/unavailable-with-alternatives`, input, staffRequestCommandResultSchema, o),
        correctConfirmation: (requestId, input, o) => post(`${base(requestId)}/correct-confirmation`, input, staffRequestCommandResultSchema, o),
    };
}
